<template>
  <div class="page">
    <Header />
    <section class="section">
      <div class="container">
        <div class="profile profile--alert">
          <NoGoalAlert />
        </div>
        <div class="section__top" style="margin-bottom: 30px;">
          <h2 class="section__title">Мой профиль</h2>
        </div>
        <div class="profile">
          <div class="profile__box profile__season-box" v-if="myActivities.length">
            <div class="profile__season">
              <div class="profile__season-header">
                <p class="profile__season-eyebrow">{{ seasonInfo.title }}</p>
                <p class="profile__season-period">
                  {{ seasonInfo.startDate }} — {{ seasonInfo.endDate }}
                </p>
              </div>
              <p class="profile__season-subtitle">Мои кластеры по активностям</p>
              <ul class="profile__season-list">
                <li
                  v-for="a in myActivities"
                  :key="a.code"
                  class="profile__season-row"
                >
                  <span class="profile__season-row-name">
                    <i class="fa-solid" :class="a.icon"></i>
                    {{ a.name }}
                  </span>
                  <span class="profile__season-row-cluster">
                    Кластер {{ a.clusterId }}
                    <span class="profile__season-range">({{ clusterLabel(a.clusterId) }})</span>
                  </span>
                  <span class="profile__season-row-goal">{{ a.goalKm }} км</span>
                </li>
              </ul>
              <div class="profile__season-edit">
                <router-link
                  to="/season/start"
                  class="profile__season-edit-link"
                >
                  Редактировать
                </router-link>
              </div>
            </div>
          </div>
          <div class="profile__box">
            <!-- <div class="profile__photo">
              <div v-if="user && user.avatar !== null" class="profile__photo-img">
                <img :src="user.avatar.url" alt="" />
              </div>
              <div v-else class="profile__photo-img">
                <img src="@/assets/img/no-avatar.jpg" alt="1" />
              </div>
              <a href="javascript:void(0)" class="profile__photo-link">Сменить фото</a>
            </div> -->
            <div class="profile__form">
              <div class="profile__form-content">
                <div class="profile__form-field">
                  <div class="profile__form-label">Имя</div>
                  <input
                    type="text"
                    v-model.trim="profile.user.name.first"
                    class="form-control"
                  />
                </div>
                <div class="profile__form-field">
                  <div class="profile__form-label">Фамилия</div>
                  <input
                    type="text"
                    v-model.trim="profile.user.name.last"
                    class="form-control"
                  />
                </div>
                <div class="profile__form-field">
                  <div class="profile__form-label">Телефон</div>
                  <input
                    type="text"
                    v-model.trim="profile.user.phone"
                    class="form-control"
                    disabled
                  />
                </div>
                <div class="profile__form-field">
                  <div class="profile__form-label">E-mail</div>
                  <input
                    type="text"
                    v-model.trim="profile.user.email"
                    class="form-control"
                    disabled
                  />
                </div>
              </div>
              
              <p class="rating__position-text">Выберите свое подразделение</p> <br> <br>
              <div class="profile__form-content">
                <div class="profile__form-field large">
                  <div class="profile__form-label">Группа</div>
                  <v-select
                    :options="regions"
                    @input="changeRegionValue"
                    :reduce="(option) => option.id"
                    :clearable="false"
                    :searchable="false"
                    placeholder="Выберите регион"
                    :get-option-label='option => option.name'
                    :get-option-key='option => option.id'
                    v-model="selectedRegion"
                  >
                  </v-select>
                </div>
                <div v-show="selectedRegion" class="profile__form-field large">
                  <div class="profile__form-label">Подразделение</div>
                  <v-select
                    :options="filteredSubunits"
                    @input="changeSubunitValue"
                    :reduce="(option) => option.id"
                    :clearable="false"
                    :searchable="false"
                    placeholder="Выберите подразделение"
                    :get-option-label='option => option.title'
                    :get-option-key='option => option.id'
                    v-model="selectedSubunit"
                  >
                  </v-select>
                </div>
              </div>
              <div class="profile__form-button">
                <button class="button button-accent-1" @click="update" v-if="!isLoading">
                  Сохранить
                </button>
                <button class="button button-accent-1" disabled v-else>
                  Сохраняем...
                </button>
              </div>
            </div>
          </div>
          <router-link to="/password" class="profile__password">Сменить пароль</router-link>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>
  
<script>
  import { mapGetters, mapActions } from 'vuex';
  import errorHandlerForResponse from '@/helpers/errorHandlerForResponse.js';

  import Vue from "vue";
  import vSelect from "vue-select";
  import "vue-select/dist/vue-select.css";

  Vue.component("v-select", vSelect);

  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import NoGoalAlert from '@/components/Season/NoGoalAlert.vue'

  export default {
    name: 'Main',

    components: {
      Header,
      Footer,
      NoGoalAlert
    },

    data() {
      return {
        isLoading: false,
        selectedRegion: null,
        selectedSubunit: null,
        profile: {
          user: {
            name: {
              first: '',
              last: '',
            },
            phone: '',
            email: '',
            club: {
              references: [],
            }
          }
        }
      }
    },

    created() {
      this.setUser();
      this.getRegions();
      this.getSubunits();
    },

    mounted() {
      this.$store.dispatch('season/getSeasonProgress');
    },

    destroyed() {
      this.$store.dispatch('season/clear');
    },

    computed: {
      ...mapGetters('auth', ['user', 'regions', 'subunits']),
      ...mapGetters('season', ['myActivities', 'seasonInfo', 'clusterLabel']),

      filteredSubunits() {
        return this.subunits.filter(subunit => subunit.region_id === this.selectedRegion);
      }
    },

    methods: {
      ...mapActions('auth', ['editProfile', 'getRegions', 'getSubunits']),
      setUser() {
        this.profile.user.name.first = this.user.name.first;
        this.profile.user.name.last = this.user.name.last;
        this.profile.user.phone = this.user.phone;
        this.profile.user.email = this.user.email;
        if(this.user.club && this.user.club.references.length > 0) {
          this.selectedRegion = this.user.club.references[0];
          this.profile.user.club.references[0] = this.user.club.references[0]
        }
        if(this.user.club && this.user.club.references.length > 1) {
          this.selectedSubunit = this.user.club.references[1];
          this.profile.user.club.references[1] = this.user.club.references[1]
        }
      },

      update() {
        this.isLoading = true;
				let profile = this.profile
				this.editProfile(profile).then(() => {
          this.isLoading = false;
          this.setUser();
          this.$toast.success('Данные обновлены')
				}).catch((e) => {
          this.isLoading = false;
					this.errorHandlerForResponse(e);
				})
			},

      changeRegionValue() {
        this.profile.user.club.references[0] = this.selectedRegion;
        this.profile.user.club.references.splice(1, 1);
        this.selectedSubunit = null;
      },

      changeSubunitValue() {
        this.profile.user.club.references[1] = this.selectedSubunit; 
      },

      errorHandlerForResponse,
    },
  }
</script>

<style lang="sass">
.vs__dropdown-toggle 
  height: 48px
  border: 1px solid #01265325
  border-radius: 8px
  padding: 0
  display: flex
  align-items: center
.vs__selected-options 
  padding: 0 15px
  height: 24.39px
.vs__selected
  padding: 0
  margin: 0
  height: 100%
  max-width: 95%
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
  display: block
  border: none
.vs--single.vs--loading .vs__selected, .vs--single.vs--open .vs__selected
  position: static
.vs__actions
  padding-right: 10px
  position: absolute
  right: 0
  top: 0
  bottom: 0
  margin: auto
.vs__dropdown-menu
  border: 1px solid #01265325
  border-top-color: transparent
  border-radius: 0 0 8px 8px
  padding: 0
  height: 200px
.vs__selected-options
  width: 100%
.vs__dropdown-option
  padding: 10px 15px
  white-space: normal 
  &:hover
    background-color: #01265325
.vs__dropdown-option--highlight
  color: #000
  background: none
.vs__dropdown-option--selected
  color: #012653
  font-weight: 700
.vs__search, .vs__search:focus
  margin: 0
  padding: 0
  border: none
.profile 
  width: 960px
  margin: auto
  @media screen and (max-width: 1020px)
    width: 100%
  &__box 
    background-color: #fff
    border-radius: 10px
    padding: 40px
    margin-bottom: 10px
    @media screen and (max-width: 760px)
      padding: 30px
  &__photo 
    display: flex 
    flex-direction: column 
    align-items: center
    margin-bottom: 40px
    &-img 
      width: 90px
      height: 90px
      border-radius: 50%
      overflow: hidden
      margin-bottom: 10px
      @media screen and (max-width: 760px)
        width: 70px
        height: 70px
      img 
        width: 100%
        height: 100%
        object-fit: cover
    &-link 
      color: #012653
      transition: all 300ms
      @media screen and (max-width: 760px)
        font-size: 14px
  &__form 
    &-content 
      display: flex
      flex-wrap: wrap
      gap: 17px
      margin-bottom: 40px
      @media screen and (max-width: 1020px)
        gap: 25px
      @media screen and (max-width: 760px)
        gap: 16px
    &-field 
      width: 32%
      @media screen and (max-width: 1020px)
        width: 48%
      @media screen and (max-width: 760px)
        width: 100%
      .form-control:disabled
        &:hover 
          border-color: #01265325
      .form-select
        cursor: pointer
      &.large 
        width: 49%
        @media screen and (max-width: 1020px)
          width: 100%
    &-label 
      margin-bottom: 10px
      font-size: 14px
    &-button 
      width: 160px
      margin: auto
  &__password
    background-color: #fff
    border-radius: 10px
    width: 100%
    display: inline-block
    padding: 20px
    color: #012653
    transition: all 300ms
</style>

<style>
.profile__season-box {
  padding: 28px 40px;
}

@media screen and (max-width: 760px) {
  .profile__season-box {
    padding: 24px 30px;
  }
}

.profile__season-header {
  display: flex;
  align-items: baseline;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}

.profile__season-eyebrow {
  font-size: 16px;
  font-weight: 700;
  color: #012653;
  margin: 0;
}

.profile__season-period {
  font-size: 13px;
  color: #6b7a8f;
  margin: 0;
}

.profile__season-subtitle {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6b7a8f;
  margin: 0 0 12px;
}

.profile__season-list {
  list-style: none;
  padding: 0;
  margin: 0;
  border-top: 1px solid #EDF3FA;
}

.profile__season-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.4fr) 7rem;
  gap: 16px;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #EDF3FA;
  font-size: 15px;
}

.profile__season-row-name {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #012653;
}

.profile__season-row-name i {
  width: 18px;
  text-align: center;
  color: #6b7a8f;
}

.profile__season-row-cluster {
  color: #012653;
  font-weight: 500;
}

.profile__season-row-goal {
  color: #6b7a8f;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  text-align: right;
  justify-self: end;
  min-width: 0;
}

.profile__season-range {
  font-weight: 500;
  color: #6b7a8f;
  font-size: 14px;
}

.profile__season-edit {
  margin-top: 14px;
}

.profile__season-edit-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 0;
  height: 34px;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 500;
  font-family: 'Golos Text', sans-serif;
  color: #012653;
  background: #fff;
  border: 1px solid #c5d0dc;
  border-radius: 6px;
  text-decoration: none;
  box-sizing: border-box;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
}

.profile__season-edit-link:hover {
  border-color: #012653;
  background: #f4f7fb;
  color: #012653;
}

@media screen and (max-width: 600px) {
  .profile__season-row {
    grid-template-columns: 1fr;
    gap: 4px;
  }

  .profile__season-row-goal {
    text-align: left;
    justify-self: start;
  }
}
</style>
  